__turbopack_context__.v({
  "floating": "StampButton-module-scss-module__MNpCGG__floating",
  "floatingContainer": "StampButton-module-scss-module__MNpCGG__floatingContainer",
});
